import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import cancerImg from './cancer-insurance.png';

const DefinitionSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-5">
      <Container>
        <Row>
          <Col lg={10} className="mx-auto">
            <Row className="gy-5 align-items-center">
              <Col lg={5} className="text-center order-lg-2">
                <Image src={cancerImg as string} fluid alt="MGA Cover cancer insurance" className="w-75" />
              </Col>
              <Col lg={7} className="p-5 order-lg-1 text-center text-lg-start">
                <h2>{t('cancerInsurancePage.definitionSection.title')}</h2>
                <p>{t('cancerInsurancePage.definitionSection.description')}</p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export { DefinitionSection };
